var React = require('react');

function IconStoryFlag (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M70 163L0 115.52L0.00705818 0H139.998L140 115.64L70 163ZM6.61255 112.017L70 154.947L133.333 112.058L133.331 6.64953H6.67506L6.61255 112.017Z","fill":"#3BFEB8"}));
}

IconStoryFlag.defaultProps = {"width":"140","height":"163","viewBox":"0 0 140 163","fill":"none"};

module.exports = IconStoryFlag;

IconStoryFlag.default = IconStoryFlag;
